 const assetDescription="Asset Description";

 const saveSuccessmessage="Data Saved Successfully.";

 const deleteConfirmationMessage="Do you want to delete?";

 const deleteSuccessMessage="Record deleted successfully.";

 const confirmBackMessage="Record(s) not Saved/Updated. Do you want to continue?";
  
  const updateSuccessMessage='Data updated successfully.';


  const generateSuccessMessage="Data Generated Successfully.";

  const months=[
     { label: "January", value: "January", id: "01" },
     { label: "February", value: "February", id: "02" },
     { label: "March", value: "March", id: "03" },
     { label: "April", value: "April", id: "04" },
     { label: "May", value: "May", id: "05" },
     { label: "June", value: "June", id: "06" },
     { label: "July", value: "July", id: "07" },
     { label: "August", value: "August", id: "08" },
     { label: "September", value: "September", id: "09" },
     { label: "October", value: "October", id: "10" },
     { label: "November", value: "November", id: "11" },
     { label: "December", value: "December", id: "12" },
   ];

   const months1=[
    { label: "January", value: "01", id: "01" },
    { label: "February", value: "02", id: "02" },
    { label: "March", value: "03", id: "03" },
    { label: "April", value: "04", id: "04" },
    { label: "May", value: "05", id: "05" },
    { label: "June", value: "06", id: "06" },
    { label: "July", value: "07", id: "07" },
    { label: "August", value: "08", id: "08" },
    { label: "September", value: "09", id: "09" },
    { label: "October", value: "10", id: "10" },
    { label: "November", value: "11", id: "11" },
    { label: "December", value: "12", id: "12" },
  ];

 const commonMessages={
      assetDescription,
      saveSuccessmessage,
      deleteConfirmationMessage,
      deleteSuccessMessage,
      confirmBackMessage,
      updateSuccessMessage,
      generateSuccessMessage,
      months,
      months1
 }
 export default commonMessages

